import api from 'common/api';
import {
  SearchGeneralMasterRequest,
  DetailGeneralMasterRequest,
  UpdateGeneralMasterRequest,
} from 'api-types/src/types/general-master';

export const getGeneralAPI = (params: SearchGeneralMasterRequest) => api.get('/general-master/list', params);

export const getGeneralKbnAPI = () => api.get('/general-master/kbnlist');

export const getGeneralDetailAPI = (params: DetailGeneralMasterRequest) => api.get('/general-master/detail', params);

export const addGeneralAPI = (params: UpdateGeneralMasterRequest) => api.post('/general-master', params);

export const updateGeneralAPI = (params: UpdateGeneralMasterRequest) => api.put('/general-master', params);

export const DOWNLOAD_EXCEL_GENERAL_MAST = '/general-master/list';
